import React, { Component } from 'react'
// import classnames from 'classnames';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardImg,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    Button,
    Input,
    FormGroup,
    Collapse,
    ModalFooter
} from "reactstrap";
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
// import { Link } from "react-router-dom";
import { API_ENDPOINT } from "../../assets/api";
import PlacesKanban from "../Joborder/men-component/PlacesKanban";
// import Dropzone from 'react-dropzone';
// import sun from "../../../assets/images/icon/sun.svg"
// import night from "../../../assets/images/icon/night.svg"
// import cloudy from "../../../assets/images/icon/cloudy.svg"
// import pin from "../../../assets/images/icon/pin-drop.svg"
// import file from "../../../assets/images/icon/file-text.svg"
import { IMAGE_ENDPOINT } from "../../assets/api";
import * as loadingData from "../Joborder/men-component/loading.json";
import FadeIn from "react-fade-in";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Lottie from "react-lottie";
import { withTranslation } from 'react-i18next';
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingData.default,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};


class EditTrip extends Component {
    constructor(props) {
        super(props)

        this.state = {
            //initial 
            mode: "",
            joborder_code: "",
            joborder_id: -1,
            tour_id: 0,
            tour_fetch_ready: false,
            tour_detail: {},
            agency_license: "",
            agency_name: "",
            step: 2,
            progress: 25,
            step_1: {
                created_at: moment().format('YYYY-MM-DD'),
                external_agencys: '',
                external_agencys_code: '',
                joborder_start: '',
                joborder_stop: '',
                // flights_external: [],
                flights_internal: [],
                inbound_type: '',
                inbound_no: '',
                inbound_date: '',
                inbound_country: '',
                outbound_type: '',
                outbound_no: '',
                outbound_date: '',
                outbound_country: '',
            },
            step_2: {
                days: [],
                places_modal_is_open: false,
                places_period_modal_is_open: false,
                guides_modal_is_open: false,
                fetch_guides: false,
                fetch_places: true,
                name_filter: true,
                guides_fee: 0,
                guides: [],
                guides_skip: 0,
                guides_take: 10,
                guides_name_filter: '',
                guides_selected_day: 0,
                searching: false,
                places: [],
                places_name_filter: '',
                places_selected: {},
                places_selected_day: 0,
                places_selected_daypart: [],
                places_selected_category: [],
                places_categorys: [],
            },
            summary: {},
            update_data: {
                tour_id: "",
                tour_name: "",
                tour_description: "",
                min_recommend: 1,
                max_recommend: 100,
                visible: "",
                tour_detail: []
            },
            regions: [],
            regionSelected: "",
            provinces: [],
            provinceSelected: "",
            isLoadingCategory: false,
            isLoadingRegion: false,
            isLoadingProvince: false,
            isSearching: false,
            isLoadingPlaces: false,
            pageSkip: 0,
            pageTake: 4,
            searchText: "",
            categorySelected: [],
            count: 0,
        }
        document.title = "เพิ่มใบสั่งงาน"

        console.log("========his.state.step_1", this.state.step_1)


        this.handleChangeVisible = this.handleChangeVisible.bind(this);
        this.searchenable = {}
    }
    async componentDidMount() {
        let tour_id = this.props.match.params.tour_id
        this.get_tour_detail(tour_id)
        this.get_places_category()
        this.getRegions()
        this.getProvinces()
        this.getCount()
        this.getPlaces()
    }

    handleChangeVisible(e) {
        console.log("Visible Selected!!" + e.target.value);
        // this.setState({ update_data: e.target.value });
        let obj = this.state.update_data
        obj.visible = e.target.value
        this.setState({
            update_data: obj
        });
    }

    async get_tour_detail(tour_id) {
        var auth = JSON.parse(await localStorage.getItem('authToken'))
        let obj = {
            tour_id: tour_id,
            lang: 'th'
        }

        var response = await fetch(API_ENDPOINT + 'api/v2/web/joborder/tour/get', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth.data.type + ' ' + auth.data.token,

            },
            body: JSON.stringify(obj)

        });
        var responseJson = await response.json();
        console.log(responseJson)
        for (var day of responseJson.detail.days) {
            day.collapse_open = false
        }
        responseJson.detail.days.sort((a, b) => (a.day > b.day) ? 1 : -1)
        // console.log(responseJson)
        for (const day of responseJson.detail.days) {
            day.dayparts.sort((a, b) => (a.daypart > b.daypart) ? 1 : -1)
            for (const daypart of day.dayparts) {
                daypart.places.sort((a, b) => (a.place_ordering > b.place_ordering) ? 1 : -1)
            }
        }

        // for(var )


        let update = this.state.update_data
        update.tour_id = responseJson.id
        update.tour_name = responseJson.name
        update.tour_description = responseJson.description
        update.min_recommend = responseJson.min_recommend
        update.max_recommend = responseJson.max_recommend
        update.visible = responseJson.visible
        this.setState({
            ...this.state,
            step_2: {
                ...this.state.step_2,
                days: responseJson.detail.days
            },
            update_data: update
        }, () => {
            console.log("this.state.step_2", this.state.step_2)
        })
    }

    async get_places_category() {
        var auth = JSON.parse(await localStorage.getItem('authToken'))
        var lang = 'th'
        var response = await fetch(API_ENDPOINT + 'api/v2/web/place/category/get?lang=' + lang, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth.data.type + ' ' + auth.data.token,
            }

        });
        var responseJson = await response.json();
        var places_categorys = responseJson
        this.setState({
            ...this.state,
            step_2: {
                ...this.state.step_2,
                places_categorys: places_categorys,
                isLoadingCategory: false
            }
        })
        console.log("this.state.step_2 places_categorys", this.state.step_2)
    }

    async getRegions() {
        var auth = JSON.parse(await localStorage.getItem('authToken'))
        var response = await fetch(
            API_ENDPOINT + "api/v2/web/data/regions/get?lang=th",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: auth.data.type + " " + auth.data.token,
                },
            }
        );
        var responseJson = await response.json();
        console.log(responseJson);
        this.setState({
            regions: responseJson,
            isLoadingRegion: false,
        });
    }

    async getProvinces() {
        var token = localStorage.getItem('authToken');
        token = JSON.parse(token)
        var province_response = await fetch(API_ENDPOINT + 'api/v2/web/data/provinces/get', {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token.data.type + ' ' + token.data.token
            },
            body: JSON.stringify({
                lang: 'th',
                region_id: this.state.regionSelected
            }) // body data type must match "Content-Type" header
        });
        var responseJson = await province_response.json();
        console.log(responseJson);
        this.setState({
            provinces: responseJson
        });
    }

    async getCount() {
        var auth = JSON.parse(await localStorage.getItem('authToken'))
        var response = await fetch(API_ENDPOINT + 'api/v2/web/place/count', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth.data.type + ' ' + auth.data.token,

            }
        });
        var responseJson = await response.json();
        this.setState({
            count: parseInt(responseJson.count)
        });
    }

    kanban_remove_places(day, daypart, place_index) {
        Swal.fire({
            title: 'ยืนยันหรือไม่ ?',
            text: "คุณต้องการลบรายการสถานที่ท่องเที่ยว ใช่หรือไม่",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ยืนยัน!'
        }).then((result) => {
            if (result.isConfirmed) {
                let dayindex = this.state.step_2.days.map(e => e.day).indexOf(day)
                let daypartindex = this.state.step_2.days[dayindex].dayparts.map(e => e.daypart).indexOf(daypart)
                var days = this.state.step_2.days
                days[dayindex].dayparts[daypartindex].places.splice(place_index, 1)
                this.setState({
                    step_2: {
                        ...this.state.step_2,
                        days: days
                    }
                }, () => {
                    Swal.fire(
                        'ลบแล้ว !',
                        'ลบสถานที่ท่องเที่ยวออกจากรายการแล้ว',
                        'success'
                    )
                })
            }
        })
    }
    reordering_places(days) {
        var places_ordering = 1
        for (var day of days) {
            for (var daypart of day.dayparts) {
                for (var place of daypart.places) {
                    place.place_ordering = places_ordering
                    places_ordering++
                }
            }
        }
        return days
    }
    kanban_move_places(from, to) {
        var days = this.state.step_2.days
        let dayfromindex = days.map(e => e.day).indexOf(from.day)
        let daypartfromindex = days[dayfromindex].dayparts.map(e => e.daypart).indexOf(from.daypart)
        let daytoindex = days.map(e => e.day).indexOf(to.day)
        let dayparttoindex = days[dayfromindex].dayparts.map(e => e.daypart).indexOf(to.daypart)
        if (dayparttoindex === -1) {
            days[dayfromindex].dayparts.push({
                daypart: to.daypart,
                places: []
            })
            dayparttoindex = days[dayfromindex].dayparts.map(e => e.daypart).indexOf(to.daypart)
        }

        var tmpplace = days[dayfromindex].dayparts[daypartfromindex].places[from.place_index]

        var existindex = days[daytoindex].dayparts[dayparttoindex].places.map(place => place.place_id).indexOf(tmpplace.place_id)

        if (existindex !== -1) {
            Swal.fire(
                'ล้มเหลว !',
                'ช่วงเวลาที่เลือกมีสถานที่ ที่เลือกอยู่แล้ว',
                'error'
            )
            return
        }

        days[dayfromindex].dayparts[daypartfromindex].places.splice(from.place_index, 1)
        var form_ordering = 1
        for (const place of days[dayfromindex].dayparts[daypartfromindex].places) {
            place.place_ordering = form_ordering
            form_ordering++
        }

        days[daytoindex].dayparts[dayparttoindex].places.splice(to.place_index, 0, tmpplace)
        var to_ordering = 1
        for (const place of days[daytoindex].dayparts[dayparttoindex].places) {
            place.place_ordering = to_ordering
            to_ordering++
        }
        this.setState({
            step_2: {
                ...this.state.step_2,
                days: days
            }
        })
    }


    async fetch_places(more = false) {
        this.setState({
            isLoadingPlaces: true, // Set loading before fetching
            step_2: {
                ...this.state.step_2,
                fetch_places: true
            }
        }, async () => {
            const { places_name_filter, places_selected_category } = this.state.step_2;
            const { regionSelected, provinceSelected, pageTake, pageSkip } = this.state;
            const auth = JSON.parse(await localStorage.getItem('authToken'));

            const requestObject = {
                name: places_name_filter,
                take: pageTake,
                skip: more ? this.state.step_2.places.length : 0,
                places_categorys: places_selected_category,
                region_id: regionSelected,
                province_id: provinceSelected
            };

            const response = await fetch(API_ENDPOINT + 'api/v2/web/joborder/place/get', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `${auth.data.type} ${auth.data.token}`,
                },
                body: JSON.stringify(requestObject)
            });

            const responseJson = await response.json();

            if (more) {
                this.setState(prevState => ({
                    step_2: {
                        ...prevState.step_2,
                        fetch_places: false,
                        places: [...prevState.step_2.places, ...responseJson]
                    }
                }));
            } else {
                this.setState({
                    step_2: {
                        ...this.state.step_2,
                        fetch_places: false,
                        places: responseJson
                    }
                });
            }

            this.setState({ isLoadingPlaces: false }); // Reset loading state after fetching
        });
    }

    add_places_to_daypart() {
        var days = this.state.step_2.days
        var daysindex = days.map(day => day.day).indexOf(this.state.step_2.places_selected_day)
        var places_selected_dayparts = this.state.step_2.places_selected_daypart
        var error = 0
        for (var places_selected_daypart of places_selected_dayparts) {
            var daypartindex = days[daysindex].dayparts.map(day => day.daypart).indexOf(places_selected_daypart)
            if (daypartindex === -1) {
                days[daysindex].dayparts.push({
                    daypart: places_selected_daypart,
                    places: [],
                })
                daypartindex = days[daysindex].dayparts.map(day => day.daypart).indexOf(places_selected_daypart)
            }
            var placesindex = days[daysindex].dayparts[daypartindex].places.map(place => place.place_id).indexOf(this.state.step_2.places_selected.id)
            if (placesindex === -1) {
                days[daysindex].dayparts[daypartindex].places.push({
                    place_id: this.state.step_2.places_selected.id,
                    place_detail: this.state.step_2.places_selected.detail,
                    place_img: this.state.step_2.places_selected.photo,
                    place_name: this.state.step_2.places_selected.name,
                    place_ordering: 0,
                })
            } else {
                error++
            }
        }
        if (error > 0) {
            Swal.fire(
                'ล้มเหลว !',
                'มีสถานที่ท่องเที่ยวในช่วงเวลาที่เลือกแล้วกรุณาเลือกใหม่อีกครั้ง',
                'error'
            )
        }
        days = this.reordering_places(days)
        this.setState({
            ...this.state,
            step_2: {
                ...this.state.step_2,
                days: days,
                places: [],
                places_name_filter: '',
                places_selected: {},
                places_selected_day: 0,
                places_selected_daypart: [],
                places_selected_category: [],
                fetch_places: false,
                places_modal_is_open: false,
                places_period_modal_is_open: false
            }
        }, () => {
            Swal.fire(
                'สำเร็จ !',
                'เพิ่มสถานที่ท่องเที่ยวในวันที่เลือกแล้ว',
                'success'
            )
        })
    }

    async editTrip(value) {
        var auth = JSON.parse(await localStorage.getItem('authToken'))
        for (var i = 0; i < value.tour_detail.length; i++) {
            value.tour_detail[i].places = []
            for (var j = 0; j < value.tour_detail[i].dayparts.length; j++) {
                for (var k = 0; k < value.tour_detail[i].dayparts[j].places.length; k++) {
                    value.tour_detail[i].places.push({
                        place_id: value.tour_detail[i].dayparts[j].places[k].place_id,
                        daypart: value.tour_detail[i].dayparts[j].daypart,
                        placeordering: value.tour_detail[i].dayparts[j].places[k].place_ordering
                    })
                }
            }

        }
        var response = await fetch(API_ENDPOINT + 'api/v2/web/tour/save', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth.data.type + ' ' + auth.data.token,

            },
            body: JSON.stringify(value)

        });
        var responseJson = await response.json();
        console.log(responseJson)
        if (responseJson.status === 'success') {
            Swal.fire(
                'สำเร็จ !',
                'แก้ไขแผนการท่องเที่ยวสำเร็จ',
                'success'
            ).then(() => {
                // window.location = "/Tripmanagement"
            })
        }
        else {
            Swal.fire(
                'ผิดพลาด !',
                'เกิดความผิดพลาดในการแก้ไขข้อมูล',
                'error'
            )
        }
    }

    async getPlaces() {
        var auth = JSON.parse(await localStorage.getItem('authToken'));
        var name = this.state.searchText;
        var url = API_ENDPOINT + 'api/v2/web/place/filter?skip=' + this.state.pageSkip +
            '&take=' + this.state.pageTake +
            '&categorys=[' + this.state.step_2.places_selected_category + ']' +
            '&name=' + name +
            '&province_id=' + this.state.provinceSelected +
            '&lang=th';

        var response = await fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth.data.type + ' ' + auth.data.token,
            }
        });

        var responseJson = await response.json();
        console.log("Fetched Places: ", responseJson); // ตรวจสอบข้อมูลที่ได้จาก API

        this.setState(prevState => ({
            step_2: {
                ...prevState.step_2,
                places: [...prevState.step_2.places, ...responseJson], // เพิ่มข้อมูลที่ได้
                fetch_places: false // หยุดการโหลด
            }
        }), () => {
            console.log(this.state.step_2.places); // ตรวจสอบสถานที่ที่ถูกโหลด
        });
    }

    async search(e) {
        let name = "";
        if (e !== undefined) {
            name = e.target.value;
        }

        this.setState({
            isSearching: true,
            searchText: name,
            pageSkip: 0,  // Reset pagination on new search
        }, async () => {
            await clearTimeout(this.searchenable);  // Clear previous timeout if exists

            this.searchenable = setTimeout(async () => {
                // Prepare the parameters to send to the fetch_places function
                const { categorySelected, regionSelected, provinceSelected, pageTake, searchText } = this.state;

                // Prepare API URL
                var url = API_ENDPOINT + 'api/v2/web/place/filter?' +
                    'skip=' + this.state.pageSkip +
                    '&take=' + pageTake +
                    '&categorys=[' + categorySelected + ']' +
                    '&name=' + searchText +
                    '&province_id=' + provinceSelected +
                    '&region_id=' + regionSelected +
                    '&lang=th';

                try {
                    // Perform API call
                    var auth = JSON.parse(await localStorage.getItem('authToken'))
                    var response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            Authorization: auth.data.type + ' ' + auth.data.token,
                        }
                    });

                    var responseJson = await response.json();
                    console.log("Response Data:", responseJson);

                    this.setState(prevState => ({
                        step_2: {
                            ...prevState.step_2,
                            places: responseJson,  // Save the fetched data to step_2.places
                            fetch_places: false    // Stop fetching indicator
                        },
                        isSearching: false        // Set searching state to false after fetching
                    }), () => {
                        console.log(this.state.step_2.places);  // Log the updated places
                    });

                } catch (error) {
                    console.error('Error fetching places:', error);
                    this.setState({
                        isSearching: false  // Set searching state to false if there's an error
                    });
                }
            }, 1000);  // Delay the fetch_places call by 1000 ms to debounce
        });

        console.log(name);
    }


    checkBox(i, id) {
        let arr = this.state.step_2.places_categorys, arrSelect = this.state.categorySelected;
        arr[i].isCheck = !arr[i].isCheck;  // Toggle the checkbox

        if (arr[i].isCheck) {
            arrSelect.push(id);  // Add the category if selected
        } else {
            arrSelect = arrSelect.filter(categoryId => categoryId !== id);  // Remove the category if unselected
        }

        this.setState({
            categorySelected: arrSelect
        }, () => {
            this.search();  // เรียก search ทุกครั้งที่เปลี่ยนหมวดหมู่
        });
    }

    selectRegion(value) {
        this.setState({
            regionSelected: value,
            provinceSelected: "", // Clear province if region changes
            isLoadingProvince: true, // Set loading for province
        }, async () => {
            await this.getProvinces(); // Fetch provinces after setting region
            this.setState({ isLoadingProvince: false }); // Reset loading state
            this.search(); // Call search every time region changes
        });
    }
    selectProvince(value) {
        this.setState({
            provinceSelected: value,
            isLoadingCategory: true, // Set loading for category
        }, async () => {
            await this.search(); // Fetch places based on province selection
            this.setState({ isLoadingCategory: false }); // Reset loading state
        });
    }

    pageControl() {
        this.setState((prevState) => ({
            pageSkip: prevState.pageSkip + 4, // เพิ่ม pageSkip
        }), () => {
            console.log(this.state); // ตรวจสอบค่า pageSkip
            this.getPlaces(); // เรียกใช้ getPlaces เพื่อโหลดข้อมูลเพิ่มเติม
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Breadcrumbs title="Edit Trip" breadcrumbItem={this.props.t("Edit Trip")} />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <button type="button" className="btn btn-primary waves-effect waves-light"
                                            onClick={() => {
                                                let obj = this.state.update_data
                                                obj.tour_detail = this.state.step_2.days
                                                this.setState({
                                                    update_data: obj
                                                }, () => {
                                                    this.editTrip(this.state.update_data)
                                                })
                                            }}>
                                            <span className="font-style-16">แก้ไขข้อมูล</span>
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Card className="card-shadow" style={{ marginTop: '1.5rem' }}>
                            <CardBody>
                                <Row>
                                    <Col lg={3} mg={3} sm={3} style={{ display: 'flex', alignItems: 'center', margin: "15px 0px" }}>
                                        <h5>ชื่อแผนการท่องเที่ยว :</h5>
                                    </Col>
                                    <Col lg={9} mg={9} sm={9}>
                                        <Input type="text" className="form-control" id="tour_name" placeholder="ชื่อทัวร์" value={this.state.update_data.tour_name}
                                            onChange={(e) => {
                                                let obj = this.state.update_data
                                                obj.tour_name = e.target.value
                                                this.setState({
                                                    update_data: obj
                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col lg={3} mg={3} sm={3} style={{ display: 'flex', alignItems: 'center', margin: "15px 0px" }}>
                                        <h5>รายละเอียดแผนการท่องเที่ยว :</h5>
                                    </Col>
                                    <Col lg={9} mg={9} sm={9}>
                                        <Input type="text" className="form-control" id="tour_description" placeholder="กรอกรายละเอียดแผนการท่องเที่ยว..." value={this.state.update_data.tour_description}
                                            onChange={(e) => {
                                                let obj = this.state.update_data
                                                obj.tour_description = e.target.value
                                                this.setState({
                                                    update_data: obj
                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col lg={3} mg={3} sm={3} style={{ display: 'flex', alignItems: 'center', margin: "15px 0px" }}>
                                        <h5>การเผยแพร่</h5>
                                    </Col>
                                    <Col lg={9} mg={9} sm={9}>
                                        <FormGroup>
                                            <div >
                                                <select
                                                    className="custom-select"
                                                    style={{ color: "#28CA00" }}
                                                    value={this.state.update_data.visible} onChange={this.handleChangeVisible}
                                                >
                                                    <option defaultValue value="1">{this.props.t("ไม่สาธารณะ")}</option>
                                                    <option defaultValue value="2">{this.props.t("สาธารณะ")}</option>
                                                    {/* <option defaultValue>สาธารณะ</option> */}
                                                    {/* <option value="1">One</option>
                                                                                            <option value="2">Two</option>
                                                                                            <option value="3">Three</option> */}
                                                </select>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    {/* <Col lg={3} mg={3} sm={3} style={{ display: 'flex', alignItems: 'center', margin: "15px 0px" }}>
                                        <h5>จำนวนต่ำสุด :</h5>
                                    </Col>
                                    <Col lg={9} mg={9} sm={9}>
                                        <Input type="text" className="form-control" id="min_recommend" placeholder="ชื่อทัวร์" value={this.state.update_data.min_recommend}
                                            onChange={(e) => {
                                                let obj = this.state.update_data
                                                obj.min_recommend = e.target.value
                                                this.setState({
                                                    update_data: obj
                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col lg={3} mg={3} sm={3} style={{ display: 'flex', alignItems: 'center', margin: "15px 0px" }}>
                                        <h5>จำนวนสูงสุด :</h5>
                                    </Col>
                                    <Col lg={9} mg={9} sm={9}>
                                        <Input type="text" className="form-control" id="max_recommend" placeholder="ชื่อทัวร์" value={this.state.update_data.max_recommend}
                                            onChange={(e) => {
                                                let obj = this.state.update_data
                                                obj.max_recommend = e.target.value
                                                this.setState({
                                                    update_data: obj
                                                })
                                            }}
                                        />
                                    </Col> */}
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="card-shadow" style={{ marginTop: '1.5rem' }}>
                            <CardBody>
                                {this.state.step === 2 && (
                                    <div>
                                        <Row style={{ marginBottom: '2%' }}>
                                            <Col lg={12}>
                                                <div className="text-right">
                                                    <button onClick={() => {
                                                        var days = this.state.step_2.days
                                                        if (days.length === 0) {
                                                            days.push({
                                                                day: 1,
                                                                dayparts: [],
                                                                collapse_open: false
                                                            })
                                                        } else {
                                                            days.push({
                                                                day: days[days.length - 1].day + 1,
                                                                dayparts: [],
                                                                collapse_open: false
                                                            })
                                                        }
                                                        days = this.reordering_places(days)
                                                        var step_1 = this.state.step_1
                                                        console.log(step_1)
                                                        var new_stop = moment(step_1.joborder_start, "YYYY-MM-DD").add('days', days.length).format('YYYY-MM-DD');
                                                        step_1.joborder_stop = new_stop
                                                        this.setState({
                                                            ...this.state,
                                                            step_1: step_1,
                                                            step_2: {
                                                                ...this.state.step_2,
                                                                days: days
                                                            }
                                                        })
                                                    }} className="btn btn-primary">
                                                        เพิ่มวันท่องเที่ยว
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                        {this.state.step_2.days.map((element, i) => {
                                            console.log(element)
                                            return (
                                                <Card key={i} style={{ border: '1px solid #C8C8C8' }}>
                                                    <CardBody>
                                                        <Row>
                                                            <Col xs={10} lg={11}>
                                                                <div onClick={() => {
                                                                    let days = this.state.step_2.days
                                                                    days[i].collapse_open = !days[i].collapse_open
                                                                    this.setState({
                                                                        ...this.state,
                                                                        step_2: {
                                                                            ...this.state.step_2,
                                                                            days: days
                                                                        }
                                                                    })
                                                                }} style={{ cursor: "pointer", paddingRight: 10, alignSelf: 'center', fontSize: 20, color: 'black' }}>
                                                                    <i className="fas fa-angle-down" style={{ marginRight: 10, cursor: 'pointer' }}></i> วันที่ {element.day}</div>
                                                            </Col>
                                                            <Col style={{ textAlign: 'right', paddingTop: '0.3rem' }} xs={2} lg={1}>
                                                                <div onClick={() => {
                                                                    Swal.fire({
                                                                        title: 'ยืนยันหรือไม่ ?',
                                                                        text: "ต้องการลบวันที่ " + (i + 1) + " ข้อมูลสถานที่ท่องเที่ยวที่เลือกไว้จะทำการลบข้อมูลทั้งหมด ยืนยัน ใช่หรือไม่ ",
                                                                        icon: 'warning',
                                                                        showCancelButton: true,
                                                                        confirmButtonColor: '#3085d6',
                                                                        cancelButtonColor: '#d33',
                                                                        cancelButtonText: 'ยกเลิก',
                                                                        confirmButtonText: 'ยืนยัน!'
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            var days = this.state.step_2.days
                                                                            days.splice(i, 1)
                                                                            this.setState({
                                                                                ...this.state,
                                                                                step_2: {
                                                                                    ...this.state.step_2,
                                                                                    days: days,
                                                                                }
                                                                            }, () => {
                                                                                Swal.fire(
                                                                                    'สำเร็จ !',
                                                                                    'ลบวันที่ที่เลือกเรียบร้อยแล้ว',
                                                                                    'success'
                                                                                )
                                                                            })
                                                                        }
                                                                    })
                                                                }}>  <i className="fas fa-trash-alt" style={{ color: '#e74242', cursor: 'pointer', }}></i></div>
                                                            </Col>
                                                        </Row>
                                                        <Collapse isOpen={element.collapse_open}>
                                                            {/* <Card>
                                                                <CardBody> */}
                                                            <Row >
                                                                <Col lg="12" className="text-right" style={{}}>
                                                                    <button onClick={() => {
                                                                        this.setState({
                                                                            ...this.state,
                                                                            step_2: {
                                                                                ...this.state.step_2,
                                                                                places_modal_is_open: !this.state.step_2.places_modal_is_open,
                                                                                fetch_places: true,
                                                                                places: [],
                                                                                places_selected_day: element.day,
                                                                            }
                                                                        }, () => {
                                                                            this.fetch_places()
                                                                        })
                                                                    }} className="btn btn-success" style={{ backgroundColor: '#42B600', borderColor: '#42B600', color: 'white' }}> <i className="fas fa-plus-circle font-size-16 align-middle mr-2"></i>เพิ่มสถานที่ท่องเที่ยว</button>
                                                                </Col>
                                                            </Row>
                                                            <div style={{ height: '100%' }}>
                                                                <div style={{ flexDirection: 'row' }}>
                                                                    <div className="board-style">
                                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                            <PlacesKanban kanban_move_places={this.kanban_move_places.bind(this)} kanban_remove_places={this.kanban_remove_places.bind(this)} index={i} days={element} ></PlacesKanban>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <Row>
                                                                <Col lg="12">
                                                                    <PlacesKanban kanban_move_places={this.kanban_move_places.bind(this)} kanban_remove_places={this.kanban_remove_places.bind(this)} index={i} days={element} ></PlacesKanban>
                                                                </Col>
                                                            </Row> */}
                                                            {/* </CardBody>
                                                            </Card> */}
                                                        </Collapse>
                                                    </CardBody>
                                                </Card>
                                            )
                                        })}
                                        <Modal id="places_modal" size="xl"
                                            className="special_modal"
                                            style={{ maxWidth: '1800px', width: '90%' }}
                                            isOpen={this.state.step_2.places_modal_is_open}
                                            toggle={() => {
                                                this.setState({
                                                    ...this.state,
                                                    step_2: {
                                                        ...this.state.step_2,
                                                        places_modal_is_open: !this.state.step_2.places_modal_is_open
                                                    }
                                                })
                                            }}>
                                            <Row>
                                                <Col xl={3} lg={12} md={12} sm={12} xs={12}>
                                                    <Card>
                                                        <CardBody>
                                                            <form className="app-search d-none d-lg-block">
                                                                <div className="position-relative">
                                                                    <span className="bx bx-search-alt" style={{ marginTop: '12px' }}></span>
                                                                    <input type="text" className="form-control" placeholder={"Search ..."} onChange={(e) => { this.search(e) }} />
                                                                </div>
                                                            </form>
                                                            <hr></hr>
                                                            <div>
                                                                <h5 className="font-size-16 mb-3 mb-category-text">{this.props.t("ภาค")}</h5>
                                                                <select
                                                                    onChange={(e) => this.selectRegion(e.target.value)}
                                                                    value={this.state.regionSelected}
                                                                    className="form-control select2" style={{ fontSize: 16 }}>
                                                                    <option value="0">{this.props.t('กรุณาเลือกภาค')}</option>
                                                                    {this.state.regions.map((element, i) => {
                                                                        return <option className="font-style-16" key={i} value={element.id}>{element.name} </option>
                                                                    })}
                                                                </select>
                                                                <hr></hr>
                                                                <h5 className="font-size-16 mb-3 mb-category-text">{this.props.t("จังหวัด")}</h5>
                                                                <select
                                                                    onChange={(e) => this.selectProvince(e.target.value)}
                                                                    value={this.state.provinceSelected}
                                                                    className="form-control select2" style={{ fontSize: 16 }}>
                                                                    <option value="0">{this.props.t('กรุณาเลือกจังหวัด')}</option>
                                                                    {this.state.provinces.map((element, i) => {
                                                                        return <option className="font-style-16" key={i} value={element.id}>{element.name} </option>
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <hr></hr>
                                                            <div >
                                                                <h5 className="font-size-16 mb-3 mb-category-text">{this.props.t('Place Category')}</h5>
                                                                {this.state.step_2.places_categorys.map((e, i) => {
                                                                    return (
                                                                        <div key={i}>
                                                                            <div className="custom-control custom-checkbox mt-2" onClick={() => { this.checkBox(i, e.id) }} >
                                                                                <Input type="checkbox" className="custom-control-input" checked={e.isCheck} />
                                                                                <Label className="custom-control-label font-style-16" htmlFor="productdiscountCheck1" style={{ paddingTop: '4px' }}>{e.name}</Label>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            <hr></hr>
                                                            <button className="btn btn-primary btn-block" style={{ backgroundColor: '#42B600', borderColor: '#42B600', color: 'white' }} onClick={() => window.open('/places/add')}>
                                                                <i className="fas fa-plus-circle mr-2"></i> <span className="font-style-16">{this.props.t("เพิ่มสถานที่ท่องเที่ยว")}</span></button>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col xl={9} lg={12} md={12} sm={12} xs={12}>
                                                    <div style={{ textAlign: 'end', paddingRight: 5, cursor: 'pointer' }}>
                                                        <h3 onClick={() => this.setState({ ...this.state, step_2: { ...this.state.step_2, places_modal_is_open: !this.state.step_2.places_modal_is_open } })}>x</h3>
                                                    </div>
                                                    <div style={{ textAlign: 'center', marginTop: -20 }}>
                                                        <h5><span style={{ color: 'rgb(34, 74, 172)' }}></span> 4 {this.props.t('Places in this category')} {this.props.t('from')} {this.state.count.toLocaleString()} {this.props.t('Places')}</h5>
                                                    </div>
                                                    {this.state.isLoadingPlaces ? ( // Use loading state here
                                                        <Row>
                                                            <Col>
                                                                <div className="text-center">
                                                                    <FadeIn>
                                                                        <div style={{ display: "flex", justifyContent: 'center' }}>
                                                                            <Card>
                                                                                <CardBody>
                                                                                    <Lottie options={defaultOptions} height={300} width={300} />
                                                                                    <div>
                                                                                        <h4 style={{ color: 'black', padding: 30 }}>กำลังเตรียมข้อมูล กรุณารอสักครู่</h4>
                                                                                    </div>
                                                                                </CardBody>
                                                                            </Card>
                                                                        </div>
                                                                    </FadeIn>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <div>
                                                            <Row className="mt-2 mr-modal">
                                                                {this.state.step_2.places.map((element, i) => {
                                                                    var img = IMAGE_ENDPOINT + "/" + element.photo.split(';')[0];
                                                                    return (
                                                                        <Col xl={6} lg={12} md={12} sm={12} xs={12} key={i}>
                                                                            <Card style={{ borderRadius: 5 }}>
                                                                                <CardImg top src={img} style={{ objectFit: 'cover', borderRadius: '5px 5px 0px 0px', width: 'auto', height: 160 }} />
                                                                                <CardBody>
                                                                                    <Row>
                                                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                                            {element.name.length < 50 ?
                                                                                                <h5 className="font-style-16 cl-black" style={{ fontWeight: 'bold' }}>{element.name}</h5>
                                                                                                :
                                                                                                <h5 className="font-style-16">{element.name.substring(0, 50)}...</h5>}
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row className="justify-content-center mt-lg-1 row">
                                                                                        <Col xs={12} sm={12} md={7} lg={7} xl={7}>
                                                                                            <Row className="ml-0">
                                                                                                <div>
                                                                                                    <img src={IMAGE_ENDPOINT + "/logo/" + element.category_icon + '.svg'} alt="" width={20} />
                                                                                                </div>
                                                                                                {element.category_name !== undefined ? (
                                                                                                    <div>
                                                                                                        {element.category_name.length < 24 ?
                                                                                                            <h6 className="font-style-14 mt-1" style={{ fontWeight: 'bold' }}>{element.category_name}</h6>
                                                                                                            :
                                                                                                            <h6 className="font-style-14 mt-1" style={{ fontWeight: 'bold' }}>{element.category_name.substring(0, 25)}...</h6>}
                                                                                                    </div>
                                                                                                ) : null}
                                                                                            </Row>
                                                                                        </Col>
                                                                                        <Col xs={12} sm={5} md={5} lg={5} xl={5}>
                                                                                            <Row className="ml-0">
                                                                                                <div>
                                                                                                    <img src={'/assets/images/icon/pin-drop.svg'} alt="" width={20} height={20} />
                                                                                                </div>
                                                                                                <h6 className="font-style-14 mt-1 ml-2" style={{ fontWeight: 'bold' }}>จังหวัด{element.province_name}</h6>
                                                                                            </Row>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <hr></hr>
                                                                                    <Row className="justify-content-center mt-lg-1 row">
                                                                                        <Col className="mt-2" xs={6} sm={6} md={6} lg={6} xl={6}>
                                                                                            <Row className="ml-0">
                                                                                                <div>
                                                                                                    <img src={'/assets/images/icon/file-text.svg'} alt="" width={20} height={20} />
                                                                                                </div>
                                                                                                <div style={{ cursor: 'pointer' }} onClick={() => {
                                                                                                    let place_id = element.id;
                                                                                                    if (place_id === undefined) {
                                                                                                        place_id = element.id;
                                                                                                    }
                                                                                                    window.open('/places/detail?placeid=' + place_id);
                                                                                                }}>
                                                                                                    <h6 className="font-style-16 mt-1 ml-2 t-detail-xs">{this.props.t('Click to view place details')}</h6>
                                                                                                </div>
                                                                                            </Row>
                                                                                        </Col>
                                                                                        <Col xs={6} sm={6} md={6} lg={6} xl={6} style={{ textAlign: "right" }}>
                                                                                            <button onClick={() => {
                                                                                                this.setState({
                                                                                                    ...this.state,
                                                                                                    step_2: {
                                                                                                        ...this.state.step_2,
                                                                                                        places_modal_is_open: false,
                                                                                                        places_period_modal_is_open: true,
                                                                                                        places_selected: element
                                                                                                    }
                                                                                                });
                                                                                            }} type="button" className="btn" style={{ backgroundColor: 'rgba(255, 0, 0, -0.7)', borderColor: '#224AAC', color: "#224AAC" }}>
                                                                                                <i className="fa fa-plus-circle pr-1 mr-2 " aria-hidden="true"></i><span className="font-style-16">{this.props.t('Choose a place')}</span>
                                                                                            </button>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </CardBody>
                                                                            </Card>
                                                                        </Col>
                                                                    );
                                                                })}
                                                            </Row>
                                                        </div>
                                                    )}
                                                    <Row style={{ alignSelf: 'center' }} onClick={() => { this.pageControl() }}>
                                                        <Col lg={12}>
                                                            <Card style={{ backgroundColor: 'transparent', borderWidth: 1, borderColor: 'lightgray', width: '98.5%' }}>
                                                                <CardBody style={{ textAlign: 'center', cursor: 'pointer' }}>
                                                                    <i className="fas fa-plus mr-2" style={{ cursor: 'pointer' }}></i><span className="font-style-16">โหลดเพิ่ม</span>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <ModalFooter>
                                            </ModalFooter>
                                        </Modal>
                                        <Modal id="places_period_modal" size={'lg'} isOpen={this.state.step_2.places_period_modal_is_open} toggle={() => {
                                            // let img = card.places.place_img.split(';')[0]
                                            console.log(this.state.step_2)
                                            this.setState({
                                                ...this.state,
                                                step_2: {
                                                    ...this.state.step_2,
                                                    places_selected: {},
                                                    places_period_modal_is_open: !this.state.step_2.places_period_modal_is_open,
                                                    places_modal_is_open: true,
                                                    places_selected_daypart: []
                                                }
                                            })
                                        }} className={''}>
                                            <ModalHeader toggle={() => {
                                                console.log(this.state.step_2)
                                                this.setState({
                                                    ...this.state,
                                                    step_2: {
                                                        ...this.state.step_2,
                                                        places_selected: {},
                                                        places_period_modal_is_open: !this.state.step_2.places_period_modal_is_open,
                                                        places_modal_is_open: true,
                                                        places_selected_daypart: []
                                                    }
                                                }, () => {
                                                    console.log(this.state.step_2)
                                                })
                                            }}>
                                                <h5 style={{ textAlign: 'left' }} className="modal-title mt-0">{this.props.t('Notification')}</h5>
                                            </ModalHeader>
                                            <ModalBody>
                                                <Row style={{ paddingTop: 15, paddingBottom: 15 }}>
                                                    <Col xs={5} sm={5} md={5} lg={5} xl={5} style={{ textAlign: 'center', padding: '10px' }}>
                                                        {typeof this.state.step_2.places_selected.photo != 'undefined' ? <img className="rounded mr-2 rounded-circle avatar-lg" alt="Skote" width="100" src={IMAGE_ENDPOINT + this.state.step_2.places_selected.photo.split(';')[0]} /> : ''}
                                                    </Col>
                                                    <Col xs={7} sm={7} md={7} lg={7} xl={7} style={{ alignSelf: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                                                        <h4 style={{ fontWeight: 'bold', color: '#224AAC' }}> {this.state.step_2.places_selected.name} </h4>
                                                        <h5 style={{ fontWeight: 'bold', color: 'black' }}>คุณต้องการไป ในช่วงเวลาใดบ้าง? </h5>
                                                    </Col>
                                                </Row>
                                                <Row style={{ borderTop: 'solid 1px rgba(0, 0, 0, 0.1)', paddingTop: 40, paddingBottom: 40 }}>
                                                    <Col lg="4" className="text-center"><input onClick={(e) => {
                                                        var places_selected_daypart = this.state.step_2.places_selected_daypart
                                                        console.log(this.state.step_2.places_selected)
                                                        if (e.target.checked) {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(1)
                                                            if (places_selected_daypart_index === -1) {
                                                                places_selected_daypart.push(1)
                                                            }
                                                        } else {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(1)
                                                            if (places_selected_daypart_index > -1) {
                                                                places_selected_daypart.splice(places_selected_daypart_index, 1);
                                                            }
                                                        }
                                                        this.setState({
                                                            ...this.state,
                                                            step_2: {
                                                                ...this.state.step_2,
                                                                places_selected_daypart: places_selected_daypart
                                                            }
                                                        }, () => {
                                                            console.log(this.state.step_2)

                                                        })
                                                    }} type="checkbox" name="dayperiod"></input> ช่วงเช้า </Col>
                                                    <Col lg="4" className="text-center"><input onClick={(e) => {
                                                        var places_selected_daypart = this.state.step_2.places_selected_daypart
                                                        if (e.target.checked) {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(2)
                                                            if (places_selected_daypart_index === -1) {
                                                                places_selected_daypart.push(2)
                                                            }
                                                        } else {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(2)
                                                            if (places_selected_daypart_index > -1) {
                                                                places_selected_daypart.splice(places_selected_daypart_index, 1);
                                                            }
                                                        }
                                                        this.setState({
                                                            ...this.state,
                                                            step_2: {
                                                                ...this.state.step_2,
                                                                places_selected_daypart: places_selected_daypart
                                                            }
                                                        }, () => {
                                                            console.log(this.state.step_2)
                                                        })
                                                    }} type="checkbox" name="dayperiod"></input> ช่วงบ่าย </Col>
                                                    <Col lg="4" className="text-center"><input onClick={(e) => {
                                                        var places_selected_daypart = this.state.step_2.places_selected_daypart
                                                        if (e.target.checked) {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(3)
                                                            if (places_selected_daypart_index === -1) {
                                                                places_selected_daypart.push(3)
                                                            }
                                                        } else {
                                                            let places_selected_daypart_index = places_selected_daypart.indexOf(3)
                                                            if (places_selected_daypart_index > -1) {
                                                                places_selected_daypart.splice(places_selected_daypart_index, 1);
                                                            }
                                                        }
                                                        this.setState({
                                                            ...this.state,
                                                            step_2: {
                                                                ...this.state.step_2,
                                                                places_selected_daypart: places_selected_daypart
                                                            }
                                                        }, () => {
                                                        })
                                                    }} type="checkbox" name="dayperiod"></input> ช่วงเย็น</Col>
                                                </Row>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => {
                                                    this.setState({
                                                        ...this.state,
                                                        step_2: {
                                                            ...this.state.step_2,
                                                            places_selected: {},
                                                            places_period_modal_is_open: !this.state.step_2.places_period_modal_is_open,
                                                            places_modal_is_open: true,
                                                            places_selected_daypart: 0
                                                        }
                                                    })
                                                }}>ยกเลิก</Button>
                                                <Button color="primary" onClick={() => {
                                                    this.setState({
                                                        ...this.state,
                                                        step_2: {
                                                            ...this.state.step_2,
                                                            places_period_modal_is_open: false,
                                                            places_modal_is_open: false,
                                                        }
                                                    }, () => {
                                                        this.add_places_to_daypart()
                                                    })
                                                }}>ยืนยัน</Button>
                                            </ModalFooter>
                                        </Modal>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Container>
                </div >
            </React.Fragment >
        )
    }
}
export default (withTranslation()(EditTrip))